import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3343d8fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sm:bg-gray-100 sm:dark:bg-gray-800 sm:p-5 flex flex-row justify-center rounded-2xl sm:h-96 lg:h-128" }
const _hoisted_2 = { class: "shadow-lg h-full rounded-xl overflow-hidden relative" }
const _hoisted_3 = { class: "z-10 w-full absolute bottom-0 left-0" }
const _hoisted_4 = { class: "z-10 item-bg-gradient w-full sm:w-auto px-6 py-4 text-white text-left" }
const _hoisted_5 = { class: "text-md mt-1 leading-6 font-medium" }
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.activeCategory), 1)
        ])
      ]),
      _createElementVNode("img", {
        src: `https://cdn.godi.se/${_ctx.activeImage}`,
        alt: "Random image",
        class: "w-full sm:h-full sm:w-auto object-contain object-contain z-0"
      }, null, 8, _hoisted_6)
    ])
  ]))
}